import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";

const TVCamara = () => {
  const [videos, setVideos] = useState([]);
  const channelId = "UCqb5teVCtj0MjyV7Z3_2UqQ";
  const apiKey = "AIzaSyDGhhUWMlnoGPJfcI-sopykld5PEmreNnM";

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        // Obter a lista de reprodução de uploads do canal
        const playlistResponse = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${channelId}&key=${apiKey}`
        );
        const playlistData = await playlistResponse.json();
        const playlistId = playlistData.items[0].contentDetails.relatedPlaylists.uploads;

        // Obter os vídeos da lista de reprodução
        const videosResponse = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=2&playlistId=${playlistId}&key=${apiKey}`
        );
        const videosData = await videosResponse.json();

        setVideos(videosData.items);
      } catch (error) {
        console.error("Erro ao buscar vídeos:", error);
      }
    };

    fetchVideos();
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        TV Câmara
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {videos.map((video) => (
          <Grid item xs={12} sm={6} md={6} key={video.snippet.resourceId.videoId}>
            <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", borderRadius: "10px", boxShadow: 3, height: "100%" }}>
              <iframe
                width="100%"
                height="315"
                src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                frameBorder="0"
                allowFullScreen
                style={{ borderRadius: "10px" }}
              ></iframe>
              <CardContent sx={{ width: "100%", textAlign: "center" }}>
                <Typography variant="h6" fontWeight="bold">
                  {video.snippet.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default TVCamara;
